module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": _vm.course.image,
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "course-name",
    class: {
      only: !_vm.teachers
    }
  }, [_vm._v("\n        " + _vm._s(_vm.course.name) + "\n      ")]), _vm._v("\n\n      " + _vm._s(_vm.teachers) + "\n      "), (_vm.course.teachers && _vm.course.teachers.length !== 0) ? _c('p', {
    staticClass: "teachers"
  }, [_vm._v("\n        " + _vm._s(_vm.course.teachers[0].name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.price) ? _c('price', {
    attrs: {
      "data": _vm.course.price
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    attrs: {
      "href": _vm.place
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6250c04","hasScoped":true}!./src/components/course-card/template.html
// module id = 427
// module chunks = 1